let resumeData = {
    "imagebaseurl":"example",
    "name": "Akshay Kumar ",
    "role": "Software Developer",
    "linkedinId":"https://www.linkedin.com/in/akshay-kumar-krishna-kumar/",
    "roleDescription": " based out of DFW who likes to work on various parts of frontend development and learn about new technologies in the area of full stack development.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/AK-AK",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/Akflash",
          "className":"fa fa-github"
        }
        ,
        {
          "name":"instagram",
          "url":"https://www.instagram.com/akshaykumar61197/",
          "className":"fa fa-instagram"
        } ,
        {
          "name":"facebook",
          "url":"https://www.facebook.com/akhy1997",
          "className":"fa fa-facebook"
        }
        ,
        {
          "name":"Leetcode",
          "url":"https://leetcode.com/akshay61197/",
          "className":"fa fa-code"
        }
      ],
    "aboutme":"I am currently a second year student at The University of Texas at Dallas and pursuing my Masters in Computer Science. I am a passionate individual for programming and coding who is looking for a full time role after I graduate in Summer 2021.",
    "address":"Dallas, Texas",
    "befquote":"One thought that keeps me going is",
    "quote": "Don't let yesterday take too much of today ",
    "website":"https://github.com/Akflash",
    "education":[
      {
        "UniversityName":"The University of Texas at Dallas",
        "url":"",
        "specialization":"Computer Science",
        "startdate":"Aug 2019",
        "enddate":"May 2021",
       
      },
      {
        "UniversityName":"Sri Sairam Engineering College, Anna University",
        "url":"",
        "specialization":"Computer Science",
        "startdate":"Aug 2015",
        "enddate":"May 2019",
      }
    ],
    "work":[
      {
        "CompanyName":"Verde Finance",
        "specialization":"Software Intern",
        "startdate":"Aug 2020",
        "enddate":"Feb 2021",
    
       },
      {
        "CompanyName":"Air Liquide Medical Systems Pvt Ltd.",
        "specialization":"Software Intern",
        "startdate":"Nov 2018",
        "enddate":"Feb 2019",
    
       },
      {
        "CompanyName":"UTD",
        "specialization":"Graduate Research Assitant",
        "startdate":"Oct 2019",
        "enddate":"Aug 2020",
      },
    ],
    "skills":[
      {
        "skillname":"Java"
      },
      {
        "skillname":"Javascript"
      },
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      },
      {
        "skillname":"Nodejs"
      },
     
      {
        "skillname":"Expressjs"
      },
      {
        "skillname":"jquery"
      }
    ],
    "portfolio":[
      {
        "key":"1",
        "name":"ONLINE GAME STORE WEB APPLICATION",
        "description":"•	Developed an e-commerce website for managing online gaming resources with functionalities including user signup/sign-in, search games, filter & update items, paging functionality for game listing for the users.",
        "imgurl":"images/gamestore.JPG"
      },
      {
        "key":"2",
        "name":"TWITTER SENTIMENT ANALYSIS  ",
        "description":"•	Sentiment Analysis was performed on real time twitter data and catergorized them as positive, negative and neutral and the final classified data was visualized using Kibana",
        "imgurl":"images/twitter.png"
      },
      {
        "key":"3",
        "name":"REINFORCEMENT LEARNING FOR PACMAN GAME    ",
        "description":"•	Deep Q-networks was used to train the Pacman agent to outrun the enemy and gain a high score by using Deep Q-learning which acts as the Reinforcement Learning agent",  
        "imgurl":"images/pacman.png"
      },
      {
        "key":"4",
        "name":"INTEGRATED LIBRARY MANAGEMENT SYSTEM",
        "description":"•	Used MySQL database that allows users to store the customer and book details. Implementation of the system was developed using TkInter-Python GUI based application with MySQL and Python was used for the backend. ",
        "imgurl":"images/library.PNG"
      }
    ]
    
  }
  
  export default resumeData